import { FormikProps } from 'formik';
import { FormValues } from '../types';
import { Box, SxProps, Typography } from '@mui/material';
import { AutomationActionType } from 'services/automation/types';
import { AtsUpdateSelector } from 'services/automation/components/AtsUpdateSelector';
import { Dropdown } from 'components/DropDown';
import { getConversationStatusOptions } from '../utils/getConversationStatusOptions';
import { ClosingMethod } from 'services/campaign/types';
import { getActionOptions } from '../utils/getActionOptions';
import { ConversationStatus } from 'generated-graphql/types';
import { validateStatusIsRejectionAction } from '../utils/validateStatusIsRejectionAction';

const container: SxProps = {
  display: 'flex',
  alignItems: 'center',
  gap: 1
};

type Props = {
  formik: FormikProps<FormValues>;
  index: number;
  atsJobId: string | null | undefined;
  closingMethod: ClosingMethod;
  conversationStatusAvailableOptions: ConversationStatus[];
  actionOptionsAvailable: AutomationActionType[];
};

export const CandidateStatusItem: React.FC<Props> = ({
  formik,
  index,
  atsJobId,
  conversationStatusAvailableOptions,
  actionOptionsAvailable,
  closingMethod
}) => {
  const requirementConditionsOptions = getConversationStatusOptions(
    conversationStatusAvailableOptions,
    closingMethod
  );

  const actionOptions = getActionOptions({
    actionOptionsAvailable
  });

  const conversationStatus =
    formik.values[index].requirementConditions[0].conversationStatus;

  return (
    <Box sx={container}>
      <Typography minWidth={80}>If status is</Typography>
      <Box width={200}>
        <Dropdown
          options={requirementConditionsOptions}
          onChange={(value) => {
            formik.setFieldValue(
              `[${index}].requirementConditions[0].conversationStatus`,
              value
            );
          }}
          value={
            formik.values[index].requirementConditions[0].conversationStatus ||
            ''
          }
        />
      </Box>
      then
      <Dropdown
        options={actionOptions}
        onChange={(value) => {
          formik.setFieldValue(`[${index}].action.type`, value);
        }}
        value={formik.values[index].action.type}
      />
      {formik.values[index].action.type === AutomationActionType.UPDATE_ATS &&
        atsJobId && (
          <AtsUpdateSelector
            atsJobId={atsJobId}
            isRejectionMode={validateStatusIsRejectionAction(
              conversationStatus
            )}
            setAtsInterviewStageId={(value) =>
              formik.setFieldValue(
                `[${index}].action.atsInterviewStageId`,
                value
              )
            }
            setAtsRejectedReasonId={(value) =>
              formik.setFieldValue(
                `[${index}].action.atsRejectedReasonId`,
                value
              )
            }
            setKomboStageId={(value) =>
              formik.setFieldValue(`[${index}].action.komboStageId`, value)
            }
            setKomboRejectionReasonId={(value) =>
              formik.setFieldValue(
                `[${index}].action.komboRejectionReasonId`,
                value
              )
            }
            atsInterviewStageId={
              formik.values[index].action.atsInterviewStageId
            }
            atsRejectedReasonId={
              formik.values[index].action.atsRejectedReasonId
            }
            komboStageId={formik.values[index].action.komboStageId}
            komboRejectionReasonId={
              formik.values[index].action.komboRejectionReasonId
            }
          />
        )}
    </Box>
  );
};
